import type { Theme } from '@material-ui/core'
import { Grid, makeStyles } from '@material-ui/core'
import SelectedIcon from '@material-ui/icons/CheckCircle'
import UnselectedIcon from '@material-ui/icons/RadioButtonUnchecked'
import React from 'react'
import Typography from '../Typography'
import type { SelectableChipProps } from './SelectableChip'

const useStyles = makeStyles<Theme, SelectableChipLargeProps>((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: ({ selected, disabled }) => {
      if (selected) {
        return theme.paintscout.palette.brand.Neutral.P96
      } else if (disabled) {
        return theme.paintscout.palette.brand.Neutral.P94
      } else {
        return theme.palette.background.paper
      }
    },
    border: ({ disabled }) =>
      `1px solid ${disabled ? theme.paintscout.palette.brand.Neutral.P85 : theme.paintscout.palette.brand.Neutral.P60}`,
    outline: '4px solid white',
    borderRadius: theme.borderRadius.md,
    margin: theme.spacing(0.4),
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    backgroundClip: 'content-box', // Make the background color apply only to the content box
    cursor: 'pointer',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: ({ selected, disabled }) => {
        if (selected) {
          return theme.paintscout.palette.brand.Neutral.P96
        } else if (disabled) {
          return theme.paintscout.palette.brand.Neutral.P94
        } else {
          return theme.palette.background.paper
        }
      },
      zIndex: -1
    },
    '& svg': {
      color: theme.paintscout.palette.brand.Neutral.P50,
      fontSize: theme.typography.pxToRem(16),
      marginRight: theme.spacing(0.5),
      marginBottom: -theme.spacing(0.25)
    }
  },
  disabled: {
    background: 'grey'
  },
  label: ({ disabled }) => {
    return {
      fontWeight: 'bolder',
      marginBottom: -theme.spacing(0.5),
      color: disabled ? theme.paintscout.palette.brand.Neutral.P70 : 'inherit'
    }
  }
}))

export interface SelectableChipLargeProps extends SelectableChipProps {
  sublabel: string
  disabled?: boolean
}

export default function SelectableChipLarge(props: SelectableChipLargeProps) {
  const classes = useStyles(props)
  const { label, disabled, sublabel = '', selected, onClick } = props

  return (
    <Grid container spacing={1} onClick={disabled ? null : onClick} className={classes.root}>
      <Grid item xs={11}>
        <Grid item xs={12}>
          <Typography variant={'body1'} className={classes.label}>
            {label}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="caption" color="textSecondary">
            {sublabel}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={1}>
        {!disabled && (selected ? <SelectedIcon /> : <UnselectedIcon />)}
      </Grid>
    </Grid>
  )
}
